import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-receipt-details',
  templateUrl: './receipt-details.component.html',
  styleUrls: ['./receipt-details.component.less']
})
export class ReceiptDetailsComponent implements OnInit {

  @Input('details') details: any;

  constructor() { }

  ngOnInit() {
  }

}
